import { useState } from 'react';
import styles from './achievments.module.css';

import musicGroup from '../assets/musicGroup.png';

import achievement1 from '../assets/Testach1.jpg';
import achievement2 from '../assets/Testach2.jpg';
import achievement4 from '../assets/Testach4.jpg';
import achievement5 from '../assets/Testach5.jpg';
import achievement6 from '../assets/Testach6.jpg';
import achievement7 from '../assets/Testach7.jpg';
import achievement8 from '../assets/Testach8.jpg';

const Achievements = () => {
  const [isPaused, setIsPaused] = useState(false);

  const achievements = [
    { id: 1, image: achievement1, alt: 'Achievement 1' },
    { id: 2, image: achievement2, alt: 'Achievement 2' },
    { id: 4, image: achievement4, alt: 'Achievement 4' },
    { id: 5, image: achievement5, alt: 'Achievement 5' },
    { id: 6, image: achievement6, alt: 'Achievement 6' },
    { id: 7, image: achievement7, alt: 'Achievement 7' },
    { id: 8, image: achievement8, alt: 'Achievement 8' }
  ];

  // Duplicate list for infinite horizontal scroll
  const duplicatedAchievements = [...achievements, ...achievements];

  return (
    <section
      id="achievements"
      className={styles.achievementsSection}
      style={{ backgroundImage: `url(${musicGroup})` }}
    >
      {/* Background Overlay */}
      <div className={styles.overlay}></div>

      <div className={styles.content}>
        <h2 className={`${styles.title} ${styles['fade-in-up']}`}>
          Achievements
        </h2>

        <div
          className={`${styles.scroller} ${styles['fade-in-up']}`}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div
            className={`${styles.track} ${isPaused ? styles.paused : ''}`}
          >
            {duplicatedAchievements.map((achievement, index) => (
              <div
                key={`${achievement.id}-${index}`}
                className={styles.card}
              >
                <img
                  src={achievement.image}
                  alt={achievement.alt || 'Achievement image'}
                  className={styles.image}
                  draggable="false"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Achievements;
